import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-crm-elenco-recapiti',
  templateUrl: './crm-elenco-recapiti.component.html',
  styleUrls: ['./crm-elenco-recapiti.component.css']
})
export class CrmElencoRecapitiComponent implements OnInit {

    @Input() titolo:string;



    service = 'crmElencoRecapitiGrid';

  constructor() { }

  ngOnInit() {

    
  }

  event(event){


    if(event.name === 'eventoCustomBottone') {
      console.log('caio');
    }

  }

}
